import React, { useState } from 'react';

import APDropdown from 'components/Dropdown/APDropdown';

const LeadRecordAdditionalContact = ({
  addEmail,
  addPhone,
  addAddress,
  addWebsite,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const Button = (
    <button
      className="button--unstyled gold button--add"
      onClick={() => setIsOpen(true)}
    >
      Add contact info
    </button>
  );

  return (
    <APDropdown
      isOpen={isOpen}
      root={null}
      triggerButton={Button}
      show={() => setIsOpen(true)}
      dismiss={() => setIsOpen(false)}
      placement="bottom-start"
    >
      <button
        className='action_buttons__button button--unstyled button--menu linked-accounts__menu-item'
        onClick={() => {
          setIsOpen(false);
          addEmail();
        }}
      >
        Add additional email
      </button>
      <button
        className='action_buttons__button button--unstyled button--menu linked-accounts__menu-item'
        onClick={() => {
          setIsOpen(false);
          addPhone();
        }}
      >
        Add additional phone
      </button>
      <button
        className='action_buttons__button button--unstyled button--menu linked-accounts__menu-item'
        onClick={() => {
          setIsOpen(false);
          addAddress();
        }}
      >
        Add additional address
      </button>
      <button
        className='action_buttons__button button--unstyled button--menu linked-accounts__menu-item'
        onClick={() => {
          setIsOpen(false);
          addWebsite();
        }}
      >
        Add additional website
      </button>
    </APDropdown>
  );
};

export default LeadRecordAdditionalContact;
